/**
 * Capitalizes the first letter of a string while keeping the rest unchanged.
 * @param {string} str - The input string to capitalize
 * @returns {string} The string with its first letter capitalized
 */
export const capitalizeFirstLetter = (str) => {
  if (!str || typeof str !== 'string') return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};
